class WishlistButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.productId = this.dataset.productId;
    if (!this.button || !this.productId) return;

    this.updateState(this.items().includes(this.productId));
    this.button.addEventListener('click', () => this.toggle());
  }

  items() {
    try {
      return JSON.parse(localStorage.getItem('ohSoPurpleWishlist') || '[]');
    } catch {
      return [];
    }
  }

  toggle() {
    const items = this.items();
    const index = items.indexOf(this.productId);
    const saved = index === -1;
    if (saved) items.push(this.productId);
    else items.splice(index, 1);

    try {
      localStorage.setItem('ohSoPurpleWishlist', JSON.stringify(items));
    } catch {
      return;
    }
    this.updateState(saved);
  }

  updateState(saved) {
    this.button.setAttribute('aria-pressed', String(saved));
    this.button.setAttribute('aria-label', `${saved ? 'Remove' : 'Add'} this product ${saved ? 'from' : 'to'} wishlist`);
  }
}

if (!customElements.get('wishlist-button')) customElements.define('wishlist-button', WishlistButton);
